const galleryCarousel = document.querySelector(".js-gallery-flkty");

if (typeof galleryCarousel != "undefined" && galleryCarousel != null) {

    const flkty = new Flickity(galleryCarousel, {
        cellAlign: "center",
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        imagesLoaded: true,
        setGallerySize: false,
        resize: true,
        // lazyLoad: 1,
        wrapAround: true
    });

    const sliderParent = galleryCarousel.parentNode.parentNode;
    const prevButtons = sliderParent.querySelectorAll(".js-gallery-prev-btn");
    const nextButtons = sliderParent.querySelectorAll(".js-gallery-next-btn");
    const galleryIndex = sliderParent.querySelectorAll(".js-gallery-index");

    prevButtons.forEach((prevButton) => {
        prevButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
        })
    });

    nextButtons.forEach((nextButton) => {
        nextButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.next();
        });
    });

    function updateStatus() {
        let slideNumber = flkty.selectedIndex + 1;
        galleryIndex.forEach((index) => {
            index.textContent = slideNumber + "/" + flkty.slides.length;
        });
    }

    updateStatus();

    flkty.on("select", updateStatus);
}